import { render, staticRenderFns } from "./imageScroll.vue?vue&type=template&id=6bc0867a&scoped=true&"
import script from "./imageScroll.vue?vue&type=script&lang=js&"
export * from "./imageScroll.vue?vue&type=script&lang=js&"
import style0 from "./imageScroll.vue?vue&type=style&index=0&id=6bc0867a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc0867a",
  null
  
)

export default component.exports